import CleengService from '@jwp/ott-common/src/services/integrations/cleeng/CleengService';
import StorageService from '@jwp/ott-common/src/services/StorageService';
import { BROADCAST_CHANNEL, GET_CUSTOMER_IP } from '@jwp/ott-common/src/modules/types';
import type { GetCustomerIP } from '@jwp/ott-common/types/get-customer-ip';
import type { BroadcastChannel } from '@jwp/ott-common/types/broadcast-channel';
import { inject, optional } from '@jwp/ott-common/src/modules/container';

/**
 * CAUTION! This function is assuming the domain will only consist maximum of
 * exactly one top level domain. So symphony.live or symphony.com. Would we
 * ever want to host the app on something like symphony.co.uk or www.localhost
 * we will have to revise the code in this function.
 */
function getNakedDomain(hostname: string) {
  const hostArray = hostname.split('.');

  if (hostArray.length === 1) {
    return hostname;
  }

  return hostArray.slice(-2).join('.');
}

// TODO use utils when https://github.com/Videodock/vd-ott-apps/pull/310 is merged
export const setCookie = (name: string, value: string, days: number, domain?: string) => {
  const expires = new Date();
  const cookieDomain = domain ? `;domain=${domain}` : '';
  expires.setDate(expires.getDate() + days);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/${cookieDomain}`;
};

export const getCookie = (name: string) => {
  const match = new RegExp('(^| )' + name + '=([^;]+)').exec(document.cookie);
  return match ? match[2] : null;
};

export const removeCookie = (name: string, domain?: string) => {
  const cookieDomain = domain ? `;domain=${domain}` : '';
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/${cookieDomain}`;
};

const AUTH_PERSIST_KEY = 'sym-auth';

type Tokens = {
  accessToken: string;
  refreshToken: string;
};

type MessageAction = 'refreshing' | 'resolved' | 'rejected';

type MessageData = {
  action: MessageAction;
  tokens?: Tokens;
};

export default class SymphonyCleengService extends CleengService {
  constructor(
    @inject(StorageService) storageService: StorageService,
    @inject(GET_CUSTOMER_IP) getCustomerIP: GetCustomerIP,
    @inject(BROADCAST_CHANNEL) @optional() channel?: BroadcastChannel<MessageData>,
  ) {
    super(storageService, getCustomerIP, channel);

    window.refreshAccessToken = async () => {
      return this.maybeRefreshAccessToken();
    };
  }
  override async getTokenFromStorage() {
    return getCookie(AUTH_PERSIST_KEY);
  }

  override async persistInStorage(tokens: Tokens | null) {
    const domain = getNakedDomain(window.location.hostname);

    if (tokens) {
      // Documentation states that refresh token is valid for 100 days max.
      setCookie(AUTH_PERSIST_KEY, JSON.stringify(tokens), 100, domain);
    } else {
      removeCookie(AUTH_PERSIST_KEY, domain);
    }
  }
}
